<template lang="pug">
  .yezza-shipping
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

    v-container.pa-0(v-else style="max-width:600px")
      v-card.pa-4(v-if="$currency.code === 'MYR'" flat text :style="[{'background-color': $vuetify.theme.themes[$theme].infoT08}, { 'border-radius' : $vuetify.breakpoint.xsOnly ? '0px' : '' }, { 'margin-top' : $vuetify.breakpoint.xsOnly ? '0px' : '16px' }]")
        div.s2.info500--text {{ $t('alert_moved_zones.title') }}
        div.c1.info500--text.mt-1 {{ $t('alert_moved_zones.text') }}&nbsp;
          span.clickable(style="text-decoration: underline;" @click="$router.push('/admin/settings/advance')") {{ $t('alert_moved_zones.action') }}
      .content.py-4.px-2    
        v-list-item
          v-list-item-content
            div.s1.basic800--text {{ $t('section_shipping.title') }}
            div.c1.basic600--text {{ $t('section_shipping.text') }}

        v-card.mx-4(outlined flat)
          v-simple-table.mytable(fixed-header)
            template(v-slot:default)
              thead(style="height: 57px")
                tr
                  th.text-left.s2.primary400--text(style="background-color: #f7f7f7") {{ $t('method') }}
                  th.text-left.s2.primary400--text.px-0.mx-0(style="background-color: #f7f7f7") {{ $t('activate') }}
                  th.text-left.s2.primary400--text.px-0.mx-0(style="background-color: #f7f7f7")
              tbody
                tr
                  td.py-2
                    div.s2.default--text {{ $t('courier') }}
                  td.py-2.px-0.mx-0
                    y-switch.mt-3(:color="$vuetify.theme.themes[$theme].success400" :disabled="settings && !settings.courier" v-model="status.enable_courier" @change="updateCourier")
                  td.py-2.px-0.mx-0
                    v-btn(v-if="settings && !settings.courier" color='textColorAccent' small height="24px" width="62px" depressed @click.stop="openCourierSettings()")
                      .button-AA-tiny.basic100--text {{ $t('setup') }}
                    v-btn.button-AA-tiny.primary500--text(v-else outlined color='primary' small @click.stop="openCourierSettings()" height="22px" width="62px")
                      div {{ $t('manage') }}
                tr
                  td.py-2
                    div.s2.default--text {{ $t('local_delivery') }}
                  td.py-2.px-0.mx-0
                    y-switch.mt-3(:color="$vuetify.theme.themes[$theme].success400" :disabled="settings && !settings.local_delivery" v-model="status.enable_local_delivery" @change="updateCourier")
                  td.py-2.px-0.mx-0
                    v-btn(v-if="settings && !settings.local_delivery" color='textColorAccent' small height="24px" width="62px" depressed @click.stop="openLocalDeliverySettings()")
                      .button-AA-tiny.basic100--text {{ $t('setup') }}
                    v-btn.button-AA-tiny.primary500--text(v-else outlined color='primary' small @click.stop="openLocalDeliverySettings()" height="22px" width="62px")
                      div {{ $t('manage') }}
        
        v-card.d-flex.align-center.pa-3.mx-4.mt-4(flat :style="$vuetify.breakpoint.smAndUp ? 'border-radius: 4px; margin-top: 8px; margin-bottom: 8px;' : ''" :color="$vuetify.theme.themes[$theme].zooPurpleT10")
          div.c1.zooPurple--text {{ $t('alert_feedback.title') }}
          v-spacer
          v-btn.button-Aa-small.pa-0.ml-3(color="transparent" text small @click="openTypeFormDialog = true")
            div.zooPurple--text {{ $t('alert_feedback.action') }}
        
        v-list-item.mt-4
          v-list-item-content
            div.s1.basic800--text {{ $t('section_pickup.title') }}
            div.c1.basic600--text {{ $t('section_pickup.text') }}

        v-card.mx-4(outlined flat)
          v-simple-table.mytable(fixed-header)
            template(v-slot:default)
              thead(style="height: 57px")
                tr
                  th.text-left.s2.primary400--text(style="background-color: #f7f7f7") {{ $t('method') }}
                  th.text-left.s2.primary400--text.px-0.mx-0(style="background-color: #f7f7f7") {{ $t('activate') }}
                  th.text-left.s2.primary400--text.px-0.mx-0(style="background-color: #f7f7f7")
              tbody
                tr
                  td.py-2
                    div.s2.default--text {{ $t('store_pickup') }}
                  td.py-2.px-0.mx-0
                    y-switch.mt-3(:color="$vuetify.theme.themes[$theme].success400" :disabled="!storepickup" v-model="status.enable_store_pickup" @change="updatePickup")
                  td.py-2.px-0.mx-0
                    v-btn(v-if="!storepickup" color='textColorAccent' small height="24px" width="62px" depressed @click.stop="openStorePickupSettings()")
                      .button-AA-tiny.basic100--text {{ $t('setup') }}
                    v-btn.button-AA-tiny.primary500--text(v-else outlined color='primary' small @click.stop="openStorePickupSettings()" height="22px" width="62px")
                      div {{ $t('manage') }}

        v-layout.mt-8
          .c1.mx-auto
            v-layout.ma-2
              div.p2 {{ $t('learn_more_about') }}
              a.ml-1.p2.textColorAccent--text.text-decoration-none(href="https://help.yezza.com/hc/en-my/articles/4412895578265-What-is-Yezza-Shipping-" target="_blank") {{ $t('shipping') }}
      
    .modals
      walk-through-shipping(v-if="showWalkThroughDialog" :open.sync="showWalkThroughDialog" :company.sync="company" :parentFullfilments="openFullfilments" @finished="fetchShippingSettings()")
      courier-address(v-if="showUpdateCourierAddress" :open.sync="showUpdateCourierAddress" :company.sync="company" @finished="showUpdateCourierSettings = true; fetchShippingSettings()")
      courier-settings(v-if="showUpdateCourierSettings" :open.sync="showUpdateCourierSettings" :company.sync="company")
      local-delivery-address(v-if="showUpdateLocalDeliveryAddress" :open.sync="showUpdateLocalDeliveryAddress" :company.sync="company" @finished="showUpdateLocalDeliverySettings = true; fetchShippingSettings()")
      local-delivery-settings(v-if="showUpdateLocalDeliverySettings" :open.sync="showUpdateLocalDeliverySettings" :company.sync="company")
      store-pickup-address(v-if="showUpdateStorePickupAddress" :open.sync="showUpdateStorePickupAddress" :company.sync="company" @finished="showUpdateStorePickupSettings = true; fetchShippingSettings()")
      store-pickup-settings(v-if="showUpdateStorePickupSettings" :open.sync="showUpdateStorePickupSettings" :company.sync="company" @updated="fetchShippingSettings()")
      type-form-view(v-if="openTypeFormDialog" :open.sync="openTypeFormDialog" :link="typeFormUrl")

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import WalkThroughShipping from '@/components/dialogs/settings/yezzashipping/WalkThroughShipping.vue'
import CourierAddress from '@/components/dialogs/settings/yezzashipping/CourierAddress.vue'
import CourierSettings from '@/components/dialogs/settings/yezzashipping/CourierSettings.vue'
import LocalDeliveryAddress from '@/components/dialogs/settings/yezzashipping/LocalDeliveryAddress.vue'
import LocalDeliverySettings from '@/components/dialogs/settings/yezzashipping/LocalDeliverySettings.vue'
import StorePickupAddress from '@/components/dialogs/settings/yezzashipping/StorePickupAddress.vue'
import StorePickupSettings from '@/components/dialogs/settings/yezzashipping/StorePickupSettings.vue'
import TypeFormView from '@/components/dialogs/TypeFormView.vue'

export default {
  name: 'YezzaShipping',
  components: { WalkThroughShipping, CourierAddress, CourierSettings, LocalDeliveryAddress, LocalDeliverySettings, StorePickupAddress, StorePickupSettings, TypeFormView},
  props: ['company'],
  data () {
    return {
      isFetching: false,
      settings: null,
      storepickup: null,
      status: {
        enable_courier: false,
        enable_local_delivery: false,
        enable_store_pickup: false
      },
      showWalkThroughDialog: false,
      showUpdateCourierAddress: false,
      showUpdateCourierSettings: false,
      showUpdateLocalDeliveryAddress: false,
      showUpdateLocalDeliverySettings: false,
      showUpdateStorePickupAddress: false,
      showUpdateStorePickupSettings: false,
      openTypeFormDialog: false,
      openFullfilments: []
    }
  },
  computed: {
    ...mapGetters({
      shipments: 'orders/getShipments'
    }),
    fullfilments () {
      const list = []
      if (!this.settings.courier) {
        list.push("courier")
      }
      if (!this.settings.local_delivery) {
        list.push("local_delivery")
      }
      if (!this.storepickup) {
        list.push("pickup")
      }
      return list
    },
    typeFormUrl () {
      return `https://yezzaio.typeform.com/to/aMO9XZuP#id=${this.company.id}`
    }
  },
  mounted () {
    this.fetchShippingSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleActivateInstallment () {
      this.installmentEnabled = true
      this.updateInvoiceSettings()
    },
    fetchShippingSettings () {
      this.isFetching = true
      this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}`)
        .then((response) => {
          this.settings = response.data
          if (this.settings.courier) { this.status.enable_courier = this.settings.courier.enabled }
          if (this.settings.local_delivery) { this.status.enable_local_delivery = this.settings.local_delivery.enabled }
          this.isFetching = false
        }).catch(() => {})
      this.$axios.get(`/shipping/settings/${this.company.slug}/storepickup`)
        .then((response) => {
          this.storepickup = response.data
          if (this.storepickup) { this.status.enable_store_pickup = this.storepickup.enabled }
          this.isFetching = false
        }).catch(() => {})
    },
    updateCourier () {
      this.axios.post(`/shipping/yezzashipping/settings/${this.company.slug}/`, this.status)
        .then(() => {this.updateExternalCourier()})
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    updatePickup () {
      this.storepickup.enabled = this.status.enable_store_pickup
      this.axios.patch(`/shipping/settings/${this.company.slug}/storepickup`, this.storepickup)
        .then(() => {this.updateExternalCourier()})
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    updateExternalCourier() {
      if (this.status.enable_courier || this.status.enable_local_delivery) {
        if (this.shipments.easyparcel) { this.axios.patch(`/shipping/settings/${this.company.slug}/easyparcel`, {enabled: false}).catch(() => {}) }
        if (this.shipments.lalamove) { this.axios.patch(`/shipping/settings/${this.company.slug}/lalamove`, {enabled: false}).catch(() => {}) }
        if (this.shipments.zepto) { this.axios.patch(`/shipping/settings/${this.company.slug}/zepto`, {enabled: false}).catch(() => {}) }
        const shipments = {
          easyparcel: false,
          zepto: false,
          lalamove: false,
          yscourier: this.status.enable_courier,
          yslocaldelivery: this.status.enable_local_delivery
        }
        this.$store.commit('orders/setShipments', shipments)
      }
  },
    openCourierSettings () {
      if (!this.settings.courier) {
        this.openFullfilments = this.fullfilments
        this.showWalkThroughDialog = true
        return
      }
      this.showUpdateCourierSettings = true
    },
    openLocalDeliverySettings () {
      if (!this.settings.local_delivery) {
        this.openFullfilments = this.fullfilments
        this.showWalkThroughDialog = true
        return
      }
      this.showUpdateLocalDeliverySettings = true
    },
    openStorePickupSettings () {
      if (!this.storepickup) {
        this.openFullfilments = ['pickup']
        this.showWalkThroughDialog = true
        return
      }
      this.showUpdateStorePickupSettings = true
    }
  }
}
</script>

<i18n>
{
  "en": {
    "alert_moved_zones": {
      "title": "We moved zones and integrations",
      "text": "You can find your shipping zones and integration settings in",
      "action": "Advanced Setup."
    },
    "section_shipping": {
      "title": "Yezza Shipping",
      "text": "Auto-calculate rates and arrange shipments quicker"
    },
    "alert_feedback": {
      "title": "Let us know what you think about Yezza Shipping",
      "action": "Leave feedback"
    },
    "section_pickup": {
      "title": "Store Pickup",
      "text": "Set pickup address and instructions for your customers"
    }
  },
  "id": {
    "alert_moved_zones": {
      "title": "Kami memindahkan zona dan integrasi",
      "text": "Anda bisa menemukan pengaturan zona dan integrasi pengiriman kamu di",
      "action": "Pengaturan Lanjutan."
    },
    "section_shipping": {
      "title": "Yezza Shipping",
      "text": "Hitung tarif otomatis dan atur pengiriman lebih cepat"
    },
    "alert_feedback": {
      "title": "Beritahu kami apa yang kamu pikirkan tentang Yezza Shipping",
      "action": "Tinggalkan masukan"
    },
    "section_pickup": {
      "title": "Pengambilan di Toko",
      "text": "Atur alamat dan instruksi pengambilan untuk pelanggan kamu"
    }
  }
}
</i18n>
